import { render, staticRenderFns } from "./one-task.vue?vue&type=template&id=3b80076e&scoped=true"
import script from "./one-task.vue?vue&type=script&lang=js"
export * from "./one-task.vue?vue&type=script&lang=js"
import style0 from "./one-task.vue?vue&type=style&index=0&id=3b80076e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b80076e",
  null
  
)

export default component.exports